<template>
  <div>
    <div class="footer">
      <div class="footer-info">
        <div class="footer-logo">
          <img src="@/assets/images/logo.png" alt="" />
        </div>
        <div class="footer-content footer-marginTop35">
          <img
            src="@/assets/images/footer/ico-addr.png"
            alt=""
            style="margin-right: 8px"
          />
          <span>江苏省南京市建邺区广聚路31号安科大厦A座16层</span>
        </div>
        <div class="footer-content footer-marginTop8">
          <img
            src="@/assets/images/footer/ico-tel.png"
            alt=""
            style="margin-right: 8px"
          />
          <span>13952070001</span>
        </div>
        <div class="footer-content footer-marginTop8">
          <img
            src="@/assets/images/footer/ico-chat.png"
            alt
            style="margin-right: 8px"
          />
          <span>ai.lekang@qq.com</span>
        </div>
      </div>
      <div class="code-wrap">
        <img src="@/assets/images/footer/code.png" alt="" />
        <div>微信公众号</div>
      </div>
    </div>
    <div class="footer-copyright footer-marginTop35">
      © 2023 - {{ year }} 南京乐康数字科技有限公司
      <a href="https://beian.miit.gov.cn" target="_blank">
        苏ICP备2024127805号
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
.footer {
  width: 100%;
  background-color: #f5f5f5;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 10%;
  box-sizing: border-box;

  .footer-logo {
    width: 160px;
    height: 160px;
    img {
      width: 160px;
      height: 160px;
    }
  }
  .footer-marginTop35 {
    margin-top: 35px;
  }
  .footer-marginTop8 {
    margin-top: 8px;
  }

  .footer-content {
    font-weight: 500;
    font-size: 18px;
    color: #333;
    line-height: 26px;
    letter-spacing: 2px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
    }
  }
  .code-wrap {
    font-size: 21px;
    text-align: center;
    img {
      width: 160px;
      height: 160px;
    }
  }
}

.footer-copyright {
  background: #b91928;
  font-size: 16px;
  color: #333;
  letter-spacing: 2px;
  color: #fff;
  text-align: center;
  padding: 20px 0;

  a {
    color: #fff;
  }
}

@media screen and (max-width: 768px) {
  .footer {
    width: 100%;
    padding: 90px;
    box-sizing: border-box;
    display: block;

    .footer-logo {
      text-align: center;
      width: 100%;
      height: 400px;
      img {
        width: 400px;
        height: 390px;
      }
    }

    .footer-content {
      font-size: 64px;
      line-height: 120px;
      letter-spacing: 6px;
      img {
        width: 120px;
        height: 120px;
      }
    }
    .code-wrap {
      display: none;
    }
  }

  .footer-copyright {
    font-weight: 400;
    font-size: 56px;
    line-height: 160px;
    letter-spacing: 10px;
    a {
      display: block;
    }
  }
}
</style>
